import { render, staticRenderFns } from "./imgUpload.vue?vue&type=template&id=0b07fb0a&scoped=true&"
import script from "./imgUpload.vue?vue&type=script&lang=js&"
export * from "./imgUpload.vue?vue&type=script&lang=js&"
import style0 from "./imgUpload.vue?vue&type=style&index=0&id=0b07fb0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07fb0a",
  null
  
)

export default component.exports